<template>
    <div
        :class="{current: currentCard === id}"
        class="card-compare"
    >
        <div class="container-box data">
            <nuxt-link
                v-if="currentCard !== id"
                :to="$prismic.linkResolver(card)"
            >
                <prismic-image
                    :img="card.data.image"
                    w="150"
                    h="94"
                />
            </nuxt-link>

            <prismic-image
                v-else
                :img="card.data.image"
                w="150"
                h="94"
            />

            <span class="font-header">{{ card.data.title }}</span>

            <ul>
                <li
                    v-for="(pro, index) in pros"
                    :key="index"
                >
                    <i class="fa-regular fa-check fa-check1" />
                    <span>{{ $prismic.asText([pro]) }}</span>
                </li>
            </ul>
        </div>

        <div
            v-if="!currentCard"
            class="container-box cta"
        >
            <button-nuxt
                :link="card"
                :text="$translate('cta_read_more', 'Läs mer')"
                size="sm"
                background="green-border"
            />
        </div>
    </div>
</template>

<script>
export default {
    props: {
        id: {
            type: String,
            required: true,
            default: String
        },
        currentCard: {
            type: String,
            required: false,
            default: String
        }
    },
    computed: {
        card() {
            return this.$store.state.cards[this.id];
        },
        pros() {
            return this.$getCategoryData(this.card).pros;
        }
    }
};
</script>

<style lang="scss" scoped>
    .card-compare.current {
        @include border(all,2px,$green);
    }

    .card-compare {
        position: relative;
        @include border-radius(10px);
        box-shadow: $bxs;
        @include font-size(14px,8px);
        @include border;

        &__inner {
            @include grid(1,20px);
            width: 100%;
            height: 80%;


        }

        .container-box {
            @include spacing(padding,4);

            &.data {
                height: calc(100% - 85px);

                .font-header {
                    display: block;
                    @include font-size(20px,8px);
                    margin: 20px 0;
                }

                img {
                    width: 100%;
                    height: auto;
                }

                ul {
                    @include grid(1,10px);
                    li {
                        @include flex(start,start);
                        @include font-size(14px,6px);
                        i {
                            @include font-size(14px,6px);
                        }
                        span {
                            margin-left: 10px;
                            flex: 1;
                        }
                    }
                }
            }

            &.cta {
                height: 85px;

                .btn {
                    width: 100%;
                }
            }
        }
    }
</style>
